'use strict';

/**
 * @classname NavTop
 * @classdesc トップナビ
 */
export default class TopNav {
	/**
	 * @constructor
	 * @param {jQuery} $e - .list--top-nav
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		const width = $e.outerWidth();
		$e.parent('.nav__inner').innerWidth(`${width}px`);
	};
};
